<div class="container">
  <ul class="progressbar">
    <li [ngClass]="{ active: step >= 1, 'inactive disabled': step <= 0 }" id="location-update">
      <i
        tabindex="0"
        class="icon-location header-icon"
        [ngClass]="{ 'active-header-icon': step >= 1 }"
        (click)="traverseInsideFlow('location', step >= 1)"></i>
      <div class="location-text-box">{{ 'basic-profile.jurisdiction.juri_check' | translate }}</div>
    </li>
    <ng-container *ngIf="!showTechnicalFormFirst">
      <li [ngClass]="{ active: step >= 2, 'inactive disabled': step <= 1 }" id="personal-data-0">
        <i
          tabindex="0"
          class="icon-info header-icon"
          [ngClass]="{ 'active-header-icon': step >= 2 }"
          (click)="traverseInsideFlow('personal-data', step >= 2)"></i>
        <div class="location-text-box">{{ 'basic-profile.jurisdiction.perData' | translate }}</div>
      </li>
      <li [ngClass]="{ active: step >= 3, 'inactive disabled': step <= 2 }" id="tech-data-0">
        <i
          tabindex="0"
          class="header-icon"
          [ngClass]="{ 'active-header-icon': step >= 3 }"
          (click)="traverseInsideFlow('facilities', step >= 3)">
          <span class="icon-technical_data1"></span>
          <span class="icon-technical_data2"></span>
          <span class="icon-technical_data3"></span>
        </i>
        <div class="location-text-box">{{ 'app.navigation.tech_data' | translate | uppercase }}</div>
      </li>
    </ng-container>
    <ng-container *ngIf="showTechnicalFormFirst">
      <li [ngClass]="{ active: step >= 2, 'inactive disabled': step <= 1 }" id="tech-data-1">
        <i
          tabindex="0"
          class="header-icon"
          [ngClass]="{ 'active-header-icon': step >= 2 }"
          (click)="traverseInsideFlow('facilities', step >= 2)">
          <span class="icon-technical_data1"></span>
          <span class="icon-technical_data2"></span>
          <span class="icon-technical_data3"></span>
        </i>
        <div class="location-text-box">{{ 'app.navigation.tech_data' | translate | uppercase }}</div>
      </li>
      <li [ngClass]="{ active: step >= 3, 'inactive disabled': step <= 2 }" id="personal-data-1">
        <i
          tabindex="0"
          class="icon-info header-icon"
          [ngClass]="{ 'active-header-icon': step >= 3 }"
          (click)="traverseInsideFlow('personal-data', step >= 3)"></i>
        <div class="location-text-box">{{ 'basic-profile.jurisdiction.perData' | translate }}</div>
      </li>
    </ng-container>
    <li [ngClass]="{ active: step >= 4, 'inactive disabled': step <= 3 }" id="upload">
      <i
        tabindex="0"
        class="icon-upload header-icon"
        [ngClass]="{ 'active-header-icon': step >= 4 }"
        (click)="traverseInsideFlow('submit', step >= 4)"></i>
      <div class="location-text-box">{{ 'app.navigation.doc_upload' | translate | uppercase }}</div>
    </li>
    <li
      *ngIf="currentInstallationFlow !== 'gridCompatibility'"
      [ngClass]="{ active: step >= 4, 'inactive disabled': step <= 3 }"
      id="submit">
      <i
        tabindex="0"
        class="icon-send header-icon"
        [ngClass]="{ 'active-header-icon': step >= 4 }"
        (click)="traverseInsideFlow('submit', step >= 4)"></i>
      <div class="location-text-box">{{ 'basic-profile.jurisdiction.inquiry' | translate }}</div>
    </li>
  </ul>
</div>
